// TODO: instructor routes

import { lazy } from 'react';

// lazy load the routes so they aren't included in the intial bundle and don't load until they are needed or until we decide to preload them (currently not preloading admin routes)
export const courses = lazy(() => import('../resources/course/instructor/InstructorCourseRouter.jsx'));
export const courseUsers = lazy(() => import('../resources/courseUser/instructor/InstructorCourseUserRouter.jsx'));
export const assessments = lazy(() => import('../resources/assessment/instructor/InstructorAssessmentRouter.jsx'));
